import React from 'react'
import { FiEdit2 } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import GetFormattedDate from './getFormattedDate'
import ReadMore from './Readmorewords'
import Readvalue from './ReadValues'
import ReadDataId from './ReadDataId'
import './ActionButtonstyles.css'
function TableColumnValues(props) {
  const {
    index,
    item,
    onAddingItem,
    posterUrl,
    editFunction,
    deleteFunction,
    status,
    approvePerson,
    ApproveOptionPermission,
    EDitOptionPermission,
    DeleteOptionPermission,
  } = props
  const Columns = [
    { colValue: item.tags, isEditable: false, readvalue: false, HeadValue: 'Tags' },
    // tags
    //     adminTagsGood
    //     adminTagsBad
    {
      colValue: item.adminTagsGood,
      isEditable: false,
      readvalue: false,
      HeadValue: 'AdminGood',
    },
    { colValue: item.adminTagsBad, isEditable: false, readvalue: false, HeadValue: 'AdminBad' },
    {
      colValue: item.placeOfBirth_En,
      isEditable: true,
      readvalue: true,
      HeadValue: 'placeOfBirth_En',
    },
    {
      colValue: item.placeOfBirth_Te,
      isEditable: true,
      readvalue: true,
      HeadValue: 'placeOfBirth_Te',
    },
    { colValue: item.status, isEditable: false, readvalue: false, HeadValue: 'status' },
    { colValue: item.nickName_En, isEditable: true, readvalue: false, HeadValue: 'nickName_En' },
    { colValue: item.nickName_Te, isEditable: true, readvalue: false, HeadValue: 'nickName_Te' },
    {
      colValue: item.otherNames_En,
      isEditable: true,
      readvalue: false,
      HeadValue: 'otherNames_En',
    },
    {
      colValue: item.otherNames_Te,
      isEditable: true,
      readvalue: false,
      HeadValue: 'otherNames_Te',
    },
    { colValue: item.birthName_En, isEditable: true, readvalue: false, HeadValue: 'birthName_En' },
    { colValue: item.birthName_Te, isEditable: true, readvalue: false, HeadValue: 'birthName_Te' },
    { colValue: item.almamater_En, isEditable: true, readvalue: false, HeadValue: 'almamater_En' },
    { colValue: item.almamater_Te, isEditable: true, readvalue: false, HeadValue: 'almamater_Te' },
    { colValue: item.family_En, isEditable: true, readvalue: false, HeadValue: 'family_En' },
    { colValue: item.family_Te, isEditable: true, readvalue: false, HeadValue: 'family_Te' },
    { colValue: item.awards_En, isEditable: true, readvalue: false, HeadValue: 'awards_En' },
    { colValue: item.awards_Te, isEditable: true, readvalue: false, HeadValue: 'awards_Te' },
    { colValue: item.occupation_En, isEditable: true, readvalue: true, HeadValue: 'occupation_En' },
    { colValue: item.occupation_Te, isEditable: true, readvalue: true, HeadValue: 'occupation_Te' },
    {
      colValue: item.currentlyActive,
      isEditable: true,
      readvalue: false,
      HeadValue: 'currentlyActive',
    },
    { colValue: item.yearsActive, isEditable: true, readvalue: true, HeadValue: 'yearsActive' },
    { colValue: item.relatives_En, isEditable: true, readvalue: true, HeadValue: 'relatives_En' },
    { colValue: item.relatives_Te, isEditable: true, readvalue: true, HeadValue: 'relatives_Te' },
    { colValue: item.spouse_En, isEditable: false, readvalue: true, HeadValue: 'spouse_En' },
    { colValue: item.spouse_Te, isEditable: false, readvalue: true, HeadValue: 'spouse_Te' },
    { colValue: item.nationality, isEditable: true, readvalue: false, HeadValue: 'nationality' },
    { colValue: item.children_En, isEditable: false, readvalue: false, HeadValue: 'children_En' },
    { colValue: item.children_Te, isEditable: false, readvalue: false, HeadValue: 'children_Te' },
    { colValue: item.genres_En, isEditable: true, readvalue: false, HeadValue: 'genres_En' },
    { colValue: item.genres_Te, isEditable: true, readvalue: false, HeadValue: 'genres_Te' },
    { colValue: item.memberOf_En, isEditable: true, readvalue: false, HeadValue: 'memberOf_En' },
    { colValue: item.memberOf_Te, isEditable: true, readvalue: false, HeadValue: 'memberOf_Te' },
    { colValue: item.parents_En, isEditable: true, readvalue: true, HeadValue: 'parents_En' },
    { colValue: item.parents_Te, isEditable: true, readvalue: true, HeadValue: 'parents_Te' },
    {
      colValue: item.notableWork_En,
      isEditable: true,
      readvalue: false,
      HeadValue: 'notableWork_En',
    },
    {
      colValue: item.notableWork_Te,
      isEditable: true,
      readvalue: false,
      HeadValue: 'notableWork_Te',
    },
    { colValue: item.honours_En, isEditable: true, readvalue: false, HeadValue: 'honours_En' },
    { colValue: item.honours_Te, isEditable: true, readvalue: false, HeadValue: 'honours_Te' },
    {
      colValue: item.instruments_En,
      isEditable: true,
      readvalue: false,
      HeadValue: 'instruments_En',
    },
    {
      colValue: item.instruments_Te,
      isEditable: true,
      readvalue: false,
      HeadValue: 'instruments_Te',
    },
    { colValue: item.residence_En, isEditable: true, readvalue: false, HeadValue: 'residence_En' },
    { colValue: item.residence_Te, isEditable: true, readvalue: false, HeadValue: 'residence_Te' },
    { colValue: item.education_En, isEditable: true, readvalue: false, HeadValue: 'education_En' },
    { colValue: item.education_Te, isEditable: true, readvalue: false, HeadValue: 'education_Te' },

    {
      colValue: item.politicalParty_En,
      isEditable: true,
      readvalue: false,
      HeadValue: 'politicalParty_En',
    },
    {
      colValue: item.politicalParty_Te,
      isEditable: true,
      readvalue: false,
      HeadValue: 'politicalParty_Te',
    },
    {
      colValue: item.otherPoliticalAffiliations_En,
      isEditable: true,
      readvalue: false,
      HeadValue: 'otherPoliticalAffiliations_En',
    },
    {
      colValue: item.otherPoliticalAffiliations_Te,
      isEditable: true,
      readvalue: false,
      HeadValue: 'otherPoliticalAffiliations_Te',
    },
    {
      colValue: item.precededBy_En,
      isEditable: true,
      readvalue: false,
      HeadValue: 'precededBy_En',
    },
    {
      colValue: item.precededBy_Te,
      isEditable: true,
      readvalue: false,
      HeadValue: 'precededBy_Te',
    },
    // { colValue: item.roles, isEditable: true, readvalue: false, HeadValue: 'roles' },
    { colValue: item.origin_En, isEditable: true, readvalue: false, HeadValue: 'origin_En' },
    { colValue: item.origin_Te, isEditable: true, readvalue: false, HeadValue: 'origin_Te' },
    { colValue: item.works_En, isEditable: true, readvalue: false, HeadValue: 'works_En' },
    { colValue: item.works_Te, isEditable: true, readvalue: false, HeadValue: 'works_Te' },
    { colValue: item.website, isEditable: true, readvalue: false, HeadValue: 'website' },
  ]
  return (
    <tr key={index} style={{ textAlign: 'center' }}>
      <td className='tdclassName' style={{ padding: '10px' }}>
        {index + 1}
      </td>
      <td className='tdclassName' style={{ padding: '10px' }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <input
            type='checkbox'
            id={index}
            name={item.PK}
            checked={item.isAdded}
            onChange={e => onAddingItem(e, item, index)}
          />
        </div>
      </td>
      <td className='tdclassName' style={{ padding: '10px' }}>
        <div
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}
        >
          {ApproveOptionPermission && status === 'draft' && (
            <span
              className='actionIconStyle'
              type='button'
              data-toggle='tooltip'
              title={'Approve Person'}
              onClick={() => approvePerson(item, index)}
            >
              <i className='fa fa-upload'></i>
            </span>
          )}
          {DeleteOptionPermission && (
            <span
              className='actionIconStyle'
              data-toggle='tooltip'
              title={'Delete Person'}
              type='button'
              onClick={() => deleteFunction(item, index)}
            >
              <i className='fa fa-trash'></i>
            </span>
          )}
          {EDitOptionPermission && (
            <Link target='_blank' to={`/editperson?${item.PK}`}>
              <span
                className='col-md-3 cursor-pointer actionIconStyle'
                data-toggle='tooltip'
                title={'Edit Person'}
              >
                <i className='fa fa-edit ' />
              </span>
            </Link>
          )}
        </div>
      </td>
      <td className='tdclassName'>
        <ReadDataId>{item.personID}</ReadDataId>
      </td>
      <td className='tdclassName'>{<img src={`${posterUrl}`} height='150' width={'150'}></img>}</td>
      <td className='tdclassName'>
        <div>
          <div>{item.personType}</div>
        </div>
      </td>
      <td className='tdclassName'>
        <div className='editicon1'>
          <div>{item.name_En}</div>
          <FiEdit2 className='editicon' onClick={() => editFunction(item, 'name_En')} />
        </div>
      </td>
      <td className='tdclassName'>
        <div>
          <div>{item.name_Te}</div>
          <FiEdit2 className='editicon' onClick={() => editFunction(item, 'name_Te')} />
        </div>
      </td>
      <td className='tdclassName' style={{ minWidth: '400px' }}>
        <div>
          <ReadMore>{item.about_En}</ReadMore>
          <FiEdit2 className='editicon' onClick={() => editFunction(item, 'about_En')} />
        </div>
      </td>
      <td className='tdclassName' style={{ minWidth: '400px' }}>
        <div>
          <div>
            <ReadMore>{item.about_Te}</ReadMore>
          </div>
          <FiEdit2 className='editicon' onClick={() => editFunction(item, 'about_Te')} />
        </div>
      </td>
      <td className='tdclassName'>
        <div>
          <div>{GetFormattedDate(parseInt(item.dateOfBirth, 10))}</div>
          <FiEdit2 className='editicon' onClick={() => editFunction(item, 'dateOfBirth')} />
        </div>
      </td>
      {Columns.map((value, index) => (
        <td key={index} className='tdclassName'>
          <div>
            {value.readvalue ? (
              <Readvalue>{value.colValue}</Readvalue>
            ) : (
              <div>{value.colValue}</div>
            )}
            {value.isEditable ? (
              <FiEdit2 className='editicon' onClick={() => editFunction(item, value.HeadValue)} />
            ) : null}
          </div>
        </td>
      ))}
    </tr>
  )
}

export default TableColumnValues
